import React, { useState, useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import GroupPurchase from './GroupPurchase';
import { groupDetailById } from '../../../../utils/services/user.service';

export default function GroupPurchaseRoute() {
  const location = useLocation();
  const { groupId } = useParams();
  const [groupDetail, setGroupDetail] = useState(location.state?.groupDetail);
  const [isLoading, setIsLoading] = useState(false);

  const fetchGroupDetail = async () => {
    if (!groupId) return;
    
    setIsLoading(true);
    try {
      const response = await groupDetailById({ group_id: groupId });
      console.log("🚀 ~ GroupPurchaseRoute ~ groupDetailById full response:", response);
      console.log("🚀 ~ GroupPurchaseRoute ~ response.data:", response.data);
      console.log("🚀 ~ GroupPurchaseRoute ~ response.data.data:", response.data?.data);
      
      let detail = null;
      
      // Handle different response structures
      if (response.data?.data) {
        // If data.data is an array, find the matching group or take first
        if (Array.isArray(response.data.data)) {
          detail = response.data.data.find(g => (g._id || g.id) === groupId) || response.data.data[0];
          console.log("🚀 ~ GroupPurchaseRoute ~ Found in array, detail:", detail);
        } else {
          // If data.data is an object
          detail = response.data.data;
        }
      } else if (response.data) {
        // If data is an array, find the matching group or take first
        if (Array.isArray(response.data)) {
          detail = response.data.find(g => (g._id || g.id) === groupId) || response.data[0];
        } else {
          detail = response.data;
        }
      }
      
      if (detail) {
        console.log("🚀 ~ GroupPurchaseRoute ~ Setting groupDetail:", detail);
        console.log("🚀 ~ GroupPurchaseRoute ~ Has user array:", Array.isArray(detail.user));
        console.log("🚀 ~ GroupPurchaseRoute ~ Has locations array:", Array.isArray(detail.locations));
        setGroupDetail(detail);
      } else {
        console.warn("🚀 ~ GroupPurchaseRoute ~ No detail found in response");
        // Fallback to location.state if fetch fails
        if (location.state?.groupDetail) {
          setGroupDetail(location.state.groupDetail);
        }
      }
    } catch (error) {
      console.error('Error fetching group detail:', error);
      // Fallback to location.state if fetch fails
      if (location.state?.groupDetail) {
        setGroupDetail(location.state.groupDetail);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    // If groupId is present, always fetch the full detail to ensure we have user and locations data
    if (groupId) {
      fetchGroupDetail();
    } else if (location.state?.groupDetail) {
      // If no groupId but we have location.state, use it
      setGroupDetail(location.state.groupDetail);
    }
  }, [groupId, location.state]);

  if (isLoading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#eaeaf0' }}>
        Loading group details...
      </div>
    );
  }

  if (!groupDetail && !isLoading) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center', color: '#eaeaf0' }}>
        Group not found. Please check the URL or try again.
      </div>
    );
  }

  return <GroupPurchase groupDetail={groupDetail} onGroupDetailRefetch={fetchGroupDetail} />;
}
